/* Clearance size band (snippets/pulse-clearance-finder.liquid).
 *
 * Women's or men's, then a size, and the collection grid shows only the styles
 * left in it. Stock is read off the Axel cards on the page: each renders a
 * .cx2-size button ONLY for a size buyable in this market, carrying the variant
 * id and both size readings, so this file owns no stock logic. A surviving card
 * gets the size on its own line under the name and its link gains ?variant=<id>, which
 * preselects that size on the product page. Nothing left puts the "sorry" tile
 * into the grid.
 *
 * Sizes are keyed by the US WOMEN'S number, unique per row of both size charts;
 * the scale only changes what the customer reads. */
(function () {
  if (window.__pulse_clearance_finder) return;
  window.__pulse_clearance_finder = true;

  function text(el) {
    if (!el) return '';
    var n = el.getAttribute('data-n'); /* size numbers are attributes since 2026-10-20 */
    return (n !== null ? n : el.textContent).replace(/\s+/g, ' ').trim();
  }

  function scaleNow() {
    var s = window.PulseSizeScale;
    return s && s.get && s.get() === 'm' ? 'm' : 'w';
  }

  function boot(root) {
    var genderSel = root.querySelector('[data-pcf-gender]');
    var sel = root.querySelector('[data-pcf-size]');
    var reveal = root.querySelector('[data-pcf-reveal]');
    var steps = root.querySelectorAll('[data-pcf-step]');
    var count = root.querySelector('[data-pcf-count]');
    var copy = root.querySelector('[data-pcf-copy]').dataset;
    var tileTpl = root.querySelector('[data-pcf-tile]');
    var wall = document.querySelector('.cx2-wall');
    if (!genderSel || !sel || !wall) return;

    /* "usm~usw~eu~uk" for every size any clearance style is made in. */
    var ladder = [];
    var seen = {};
    (root.getAttribute('data-ladder') || '').split('|').forEach(function (row) {
      var p = row.split('~');
      if (p.length < 2 || !p[1] || seen[p[1]]) return;
      seen[p[1]] = true;
      ladder.push({ m: p[0], w: p[1], eu: p[2] || '', uk: p[3] || '' });
    });
    ladder.sort(function (a, b) { return parseFloat(a.w) - parseFloat(b.w); });

    /* Each card, with its buyable sizes keyed by the women's number. */
    var cards = [];
    var cells = wall.querySelectorAll('.cx-wall__cell[data-cx2]');
    for (var i = 0; i < cells.length; i++) {
      var link = cells[i].querySelector('.cx-wall__link');
      var card = { cell: cells[i], link: link, base: link ? link.getAttribute('href') : '', meta: cells[i].querySelector('.cx2-meta'), tag: cells[i].querySelector('[data-cx2-off]'), price: cells[i].querySelector('.cx-meta__price'), sizes: {} };
      card.priceText = card.price ? card.price.textContent : '';
      var btns = cells[i].querySelectorAll('[data-cx2-add]');
      for (var j = 0; j < btns.length; j++) {
        var w = text(btns[j].querySelector('.cx2-w'));
        if (w) card.sizes[w] = btns[j];
      }
      cards.push(card);
    }
    if (!cards.length || !ladder.length) return;
    root.hidden = false;

    var tile = null;

    function sizeWord(row, scale) {
      var us = scale === 'm' ? row.m : row.w;
      /* Same order as the cart line: US · UK · EU (UK added 2026-09-18). */
      return (scale === 'm' ? copy.men : copy.women) + ' US ' + us + (row.uk ? ' · UK ' + row.uk : '') + (row.eu ? ' · EU ' + row.eu : '');
    }

    function leftIn(w) {
      var n = 0;
      for (var k = 0; k < cards.length; k++) if (cards[k].sizes[w]) n++;
      return n;
    }

    function fillSelect(scale) {
      var keep = sel.value;
      while (sel.options.length > 1) sel.remove(1);
      ladder.forEach(function (row) {
        var o = document.createElement('option');
        o.value = row.w;
        o.textContent = sizeWord(row, scale) + (leftIn(row.w) === 0 && copy.soldout ? ' (' + copy.soldout + ')' : '');
        sel.appendChild(o);
      });
      sel.value = keep;
    }

    function open(isOpen) {
      reveal.classList.toggle('is-open', isOpen);
      reveal.inert = !isOpen;
    }

    function showTile(on) {
      if (on && !tile && tileTpl) {
        tile = tileTpl.content.firstElementChild.cloneNode(true);
        wall.appendChild(tile);
      } else if (!on && tile) {
        tile.parentNode.removeChild(tile);
        tile = null;
      }
    }

    /* Stock-message controls remain: realtime shows low stock only; placeholder
       also shows availability above the threshold. No numeric inventory is sent. */
    function leftText(btn) {
      var mode = copy.leftMode;
      var level = btn.getAttribute('data-cx2-stock-level');
      if (!mode || !level || (level !== 'low' && mode !== 'placeholder')) return '';
      return btn.getAttribute('data-cx2-stock-message') || '';
    }

    function render() {
      var scale = scaleNow();
      var w = genderSel.value ? sel.value : '';
      var row = null;
      for (var r = 0; r < ladder.length; r++) if (ladder[r].w === w) row = ladder[r];
      var n = w ? leftIn(w) : 0;

      steps[0].classList.toggle('is-done', !!genderSel.value);
      steps[1].classList.toggle('is-done', !!w);

      cards.forEach(function (c) {
        var btn = w ? c.sizes[w] : null;
        c.cell.classList.toggle('is-out', !!w && !btn);
        var pick = c.meta && c.meta.querySelector('.cx2-pick');
        if (btn) {
          if (!pick && c.meta) {
            pick = document.createElement('span');
            pick.className = 'cx2-pick';
            c.meta.appendChild(pick);
          }
          /* The same reading as the dropdown, on its own line under the name. */
          if (pick) pick.textContent = row ? sizeWord(row, scale) : '';
          var left = c.meta && c.meta.querySelector('.cx2-left');
          var lt = leftText(btn);
          if (lt && pick) {
            if (!left) {
              left = document.createElement('span');
              left.className = 'cx2-left';
              pick.insertAdjacentElement('afterend', left);
            }
            left.textContent = lt;
          } else if (left) {
            left.parentNode.removeChild(left);
          }
          if (c.link) c.link.setAttribute('href', c.base + (c.base.indexOf('?') < 0 ? '?' : '&') + 'variant=' + btn.getAttribute('data-cx2-add'));
          /* The red tag says this size's own discount; "Up to" is the resting text. */
          if (c.tag) {
            var pct = btn.getAttribute('data-cx2-pct');
            c.tag.textContent = pct && copy.tagOff ? copy.tagOff.replace('[pct]', pct) : c.tag.getAttribute('data-upto');
          }
          /* The chosen size's own price replaces "From ..." (Andre, 2026-09-17). */
          if (c.price && btn.getAttribute('data-cx2-price')) c.price.textContent = btn.getAttribute('data-cx2-price');
        } else {
          if (pick) pick.parentNode.removeChild(pick);
          var gone = c.meta && c.meta.querySelector('.cx2-left');
          if (gone) gone.parentNode.removeChild(gone);
          if (c.link) c.link.setAttribute('href', c.base);
          if (c.tag) c.tag.textContent = c.tag.getAttribute('data-upto');
          if (c.price) c.price.textContent = c.priceText;
        }
      });
      if (w) wall.setAttribute('data-pcf-filtered', '1');
      else wall.removeAttribute('data-pcf-filtered');
      showTile(!!w && !n);

      count.textContent = '';
      if (!w) return;
      if (n) {
        var b = document.createElement('b');
        b.textContent = n + ' ' + (n === 1 ? copy.one : copy.many);
        var parts = (copy.count || '[count] for [size]').split('[count]');
        var tail = (parts[1] || '').split('[size]');
        count.appendChild(document.createTextNode(parts[0]));
        count.appendChild(b);
        count.appendChild(document.createTextNode(tail[0] + (row ? sizeWord(row, scale) : '') + (tail[1] || '')));
      }
      if (copy.showAll) {
        var a = document.createElement('a');
        a.href = '#';
        a.textContent = copy.showAll;
        a.addEventListener('click', function (e) {
          e.preventDefault();
          sel.value = '';
          render();
        });
        count.appendChild(a);
      }
    }

    /* The site's scale changed (here or anywhere): relabel the sizes and, once
       the first step has been answered, keep it in step. */
    function paint() {
      var scale = scaleNow();
      if (genderSel.value) genderSel.value = scale;
      fillSelect(scale);
      render();
    }

    genderSel.addEventListener('change', function () {
      var g = genderSel.value;
      open(!!g);
      if (g && window.PulseSizeScale && window.PulseSizeScale.set) window.PulseSizeScale.set(g);
      /* set() is a no-op when the scale is already g, so paint here as well. */
      paint();
    });
    sel.addEventListener('change', render);
    if (window.PulseSizeScale && window.PulseSizeScale.onChange) window.PulseSizeScale.onChange(paint);
    /* The size drawer's Select (snippets/pulse-size-drawer.liquid) answers both
       steps at once. The drawer's own women's / men's switch already went through
       PulseSizeScale, so the scale is the gender. */
    document.addEventListener('pulse:size-pick', function (e) {
      var usw = e.detail && e.detail.usw;
      if (!usw) return;
      genderSel.value = scaleNow();
      open(true);
      paint();
      sel.value = usw;
      render();
      root.scrollIntoView({ block: 'start', behavior: 'smooth' });
    });
    /* No pulse-product.js on a collection page, so the drawer's chart column
       follows the scale from here. */
    var drawerGender = function () {
      var d = document.getElementById('SizeDrawer');
      if (d) d.setAttribute('data-pulse-gender', scaleNow() === 'm' ? 'men' : 'women');
    };
    if (window.PulseSizeScale && window.PulseSizeScale.onChange) window.PulseSizeScale.onChange(drawerGender);
    drawerGender();
    paint();
  }

  function init() {
    var roots = document.querySelectorAll('[data-pcf]');
    for (var i = 0; i < roots.length; i++) {
      if (!roots[i].__pcf) { roots[i].__pcf = true; boot(roots[i]); }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
